import { useMemo } from 'react';

import { computePreviewRows, isRowIncomplete } from './reallocation.utils';
import type { PreviewRow, ReassignmentRowState } from './types';
import type { BatchAllocationDetail, ReallocationBatchKey } from '../../types/response';

interface BatchSectionViewModel {
  batch: BatchAllocationDetail;
  rows: ReassignmentRowState[];
  previewRows: PreviewRow[];
  hasEmptyRow: boolean;
}

const createBatchSectionViewModel = (
  batch: BatchAllocationDetail,
  rowsByBatch: Partial<Record<ReallocationBatchKey, ReassignmentRowState[]>>
): BatchSectionViewModel => {
  const rows = rowsByBatch[batch.batch] ?? [];

  return {
    batch,
    rows,
    previewRows: computePreviewRows(batch.perAnnotator, rows),
    hasEmptyRow: rows.some(isRowIncomplete),
  };
};

/** Per-batch view model for Step2Configure: preview rows + whether a row is still incomplete. */
export const useStep2Configure = (
  selectedBatchDetails: BatchAllocationDetail[],
  rowsByBatch: Partial<Record<ReallocationBatchKey, ReassignmentRowState[]>>
): BatchSectionViewModel[] =>
  useMemo(
    () => selectedBatchDetails.map((batch) => createBatchSectionViewModel(batch, rowsByBatch)),
    [selectedBatchDetails, rowsByBatch]
  );
